import { DoubleLeftOutlined, DoubleRightOutlined } from '@ant-design/icons';
import FilterOutlined from '@ant-design/icons/lib/icons/FilterOutlined';
import Badge from 'antd/lib/badge';
import Button from 'antd/lib/button';
import React from 'react';

interface ISidebarFiltersGroupCollapseProps {
    collapsed: boolean;
    setCollapsed: (value: boolean) => void;
    selectedItemsCount: number | null;
}

export const SidebarFiltersGroupCollapse: React.FC<ISidebarFiltersGroupCollapseProps> = ({ collapsed, setCollapsed, selectedItemsCount }) => {
    return (
        <div
            style={{
                position: 'absolute',
                right: collapsed ? 'auto' : 8,
                left: collapsed ? '50%' : 'auto',
                transform: collapsed ? 'translateX(-50%)' : 'none',
                top: 8,
                zIndex: 1001,
            }}
        >
            <Button type="text" onClick={() => setCollapsed(!collapsed)} style={{ padding: '0 4px' }}>
                <Badge
                    size="small"
                    showZero={false}
                    overflowCount={99}
                    count={collapsed ? selectedItemsCount : null}
                    color="white"
                    style={{ color: 'var(--ant-color-primary)' }}
                    offset={[4, -2]}
                >
                    <FilterIcons collapsed={collapsed} />
                </Badge>
            </Button>
        </div>
    );
};

const FilterIcons: React.FC<{ collapsed: boolean }> = ({ collapsed }) => {
    return (
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
            {/* Close filter arrows */}
            {!collapsed && <DoubleLeftOutlined style={{ color: 'var(--ant-color-primary)', fontSize: 14 }} />}

            <FilterOutlined style={{ color: collapsed ? 'white' : 'var(--ant-color-primary)', fontSize: 20 }} />

            {/* Open filter arrows */}
            {collapsed && <DoubleRightOutlined style={{ color: 'white', fontSize: 14 }} />}
        </div>
    );
};
